/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './addReaction.defs'
export { main as default } from './addReaction.defs'
